import { render, staticRenderFns } from "./UserManagementComp.vue?vue&type=template&id=2900510a"
import script from "./UserManagementComp.vue?vue&type=script&lang=js"
export * from "./UserManagementComp.vue?vue&type=script&lang=js"
import style0 from "./UserManagementComp.vue?vue&type=style&index=0&id=2900510a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports